import React from 'react';
import { useNavigate } from 'react-router-dom';
import DataFlowDashboard from '../../dataflow/components/dashboard/DataFlowDashboard';
import '@xyflow/react/dist/style.css';
import '../../dataflow/styles/tailwind.generated.css';
import '../../dataflow/styles/theme.css';
import '../../dataflow/components/flow/flow.css';
import './EnterpriseDataFlow.css';

/**
 * 전사 모니터링 > 데이터 수집 흐름 (데모)
 *
 * 이 화면만 MainLayout(상단 헤더 + 좌측 메뉴)을 쓰지 않고 뷰포트 전체를 쓴다.
 * 노드 71개 그래프라 가로 폭이 클수록 읽기 쉬워서, 헤더 60px·사이드바 60~280px 를 회수한다.
 * 대신 좌측 메뉴로 돌아갈 길이 없어지므로 배너 우측에 "나가기" 버튼을 둔다.
 *
 * ⚠ 실제 설비·수집기와 연결돼 있지 않다. 화면 구성을 보여주기 위한 목업이며,
 * 데이터는 브라우저 안의 시뮬레이터(dataflow/lib/pipeline-simulator.js)가 만든다.
 * 백엔드 호출도 DB 접근도 없다 — 이 페이지는 fetch 를 한 번도 하지 않는다.
 *
 * 실제 수집 데이터로 바꾸려면 dataflow/components/dashboard/DataFlowDashboard.jsx 의
 * useEffect(시뮬레이터 기동) 만 스냅샷 API 폴링으로 교체하면 된다. 나머지(store·그래프·애니메이션)는
 * 전달 방식을 모른다.
 */
function EnterpriseDataFlow() {
  const navigate = useNavigate();

  return (
    <div className="dataflow-page">
      <div className="dataflow-demo-banner" role="status">
        <span className="material-symbols-outlined" aria-hidden="true">
          info
        </span>
        <span className="dataflow-demo-banner-text">
          <strong>데모 화면입니다.</strong> 실제 설비 수집 상태가 아니며, 표시되는 설비·처리량·장애
          이벤트는 모두 예시 데이터입니다.
        </span>
        <button
          type="button"
          className="dataflow-exit-btn"
          onClick={() => navigate('/enterprise')}
          title="전사 모니터링으로 돌아가기"
        >
          <span className="material-symbols-outlined" aria-hidden="true">
            close
          </span>
          나가기
        </button>
      </div>
      <div className="dataflow-root">
        <DataFlowDashboard />
      </div>
    </div>
  );
}

export default EnterpriseDataFlow;
